// extracted by mini-css-extract-plugin
module.exports = {"items":"how-it-works_items__167Lr","item":"how-it-works_item__2YQma","item__img__chart":"how-it-works_item__img__chart__3X--T","texts":"how-it-works_texts__-vEE3"};